export const bodyPartMap: {} = {
  1: {
    cx: 155,
    cy: 66,
  },
  2: {
    cx: 155,
    cy: 100,
  },
  4: {
    cx: 211,
    cy: 149,
  },
  3: {
    cx: 97,
    cy: 149,
  },
  5: {
    cx: 155,
    cy: 163,
  },
  7: {
    cx: 183,
    cy: 237,
  },
  6: {
    cx: 126,
    cy: 237,
  },
  9: {
    cx: 183,
    cy: 329,
  },
  8: {
    cx: 126,
    cy: 329,
  },
  10: {
    cx: 155,
    cy: 26,
  },
  11: {
    cx: 415,
    cy: 30,
  },
  12: {
    cx: 381,
    cy: 89,
  },
  13: {
    cx: 455,
    cy: 89,
  },
  23: {
    cx: 217,
    cy: 197,
  },
  22: {
    cx: 92,
    cy: 197,
  },
  19: {
    cx: 352,
    cy: 223,
  },
  18: {
    cx: 480,
    cy: 223,
  },
  17: {
    cx: 390,
    cy: 289,
  },
  16: {
    cx: 441,
    cy: 289,
  },
  15: {
    cx: 395,
    cy: 382,
  },
  14: {
    cx: 438,
    cy: 382,
  },
  24: {
    cx: 357,
    cy: 163,
  },
  25: {
    cx: 477,
    cy: 163,
  },
  20: {
    cx: 441,
    cy: 186,
  },
  21: {
    cx: 394,
    cy: 186,
  },
};
